var envirment_id = "pr";

// 商品画像パスリスト
var goodsImgList = {
    "dev" : "http://10.235.27.7:8802/ols/component/goods/images/model/",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/goods/images/model/",
    "browserstack": "https://online-shop.mb.softbank.jp/ols/component/goods/images/model/",
    "it1" : "http://10.235.27.7:8802/ols/component/goods/images/model/",
    "it2" : "http://10.235.27.7:8802/ols/component/goods/images/model/",
    "st" : "https://online-shop.mb.softbank.jp/ols/component/goods/images/model/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/goods/images/model/",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/goods/images/model/",
    "default" : "http://10.235.27.7:8802/ols/component/goods/images/model/"
};

//確認画面スマホ商品画像パスリスト
var confirmSmartGoodsImgList = {
    "dev" : "http://10.235.27.7:8802/ols/component/goods/images/tandem/full/",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/goods/images/tandem/full/",
    "browserstack": "https://online-shop.mb.softbank.jp/ols/component/goods/images/tandem/full/",
    "it1" : "http://10.235.27.7:8802/ols/component/goods/images/tandem/full/",
    "it2" : "http://10.235.27.7:8802/ols/component/goods/images/tandem/full/",
    "st" : "https://online-shop.mb.softbank.jp/ols/component/goods/images/tandem/full/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/goods/images/tandem/full/",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/goods/images/tandem/full/",
    "default" : "http://10.235.27.7:8802/ols/component/goods/images/tandem/full/"
};

//確認画面スマホ以外商品画像パスリスト
var confirmSmartNoneGoodsImgList = {
    "dev" : "http://10.235.27.7:8802/ols/component/goods/images/column/full/",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/goods/images/column/full/",
    "browserstack": "https://online-shop.mb.softbank.jp/ols/component/goods/images/column/full/",
    "it1" : "http://10.235.27.7:8802/ols/component/goods/images/column/full/",
    "it2" : "http://10.235.27.7:8802/ols/component/goods/images/column/full/",
    "st" : "https://online-shop.mb.softbank.jp/ols/component/goods/images/column/full/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/goods/images/column/full/",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/goods/images/column/full/",
    "default" : "http://10.235.27.7:8802/ols/component/goods/images/column/full/"
};

//カード会社画像パスリスト
var cardCompanyImgList = {
    "dev" : "http://10.235.27.7:8802/ols/component/common/images/",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/common/images/",
    "browserstack": "https://online-shop.mb.softbank.jp/ols/component/common/images/",
    "it1" : "http://10.235.27.7:8802/ols/component/common/images/",
    "it2" : "http://10.235.27.7:8802/ols/component/common/images/",
    "st" : "https://online-shop.mb.softbank.jp/ols/component/common/images/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/common/images/",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/common/images/",
    "default" : "http://10.235.27.7:8802/ols/component/common/images/"
};

//その他の確認書類URLリスト
var kakuninList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "browserstack": "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "it1" : "http://10.235.27.7:8802/ols/component/rect/kakunin.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/kakunin.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/kakunin.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/kakunin.html"
};

// olsInitStringリスト
var olsInitStringList = {
    "dev" : "",
    "dev_mock" : 'Utils.loadScript("../mock/js/jquery.mockjax.js", function () {'
                + "    console.log('script loaded');"
                + '    $.mockjaxSettings.matchInRegistrationOrder = false;'
                + '    Utils.loadScript("../mock/all.js", function () {'
                + "        console.log('mock script loaded.');"
                + '        OLS.init();'
                + '    });'
                + '});',
    "browserstack" : "",
    "it1" : "",
    "it2" : "OLS.init()",
    "st" : 'Utils.loadScript("../mock/js/jquery.mockjax.js", function () {'
                + "    console.log('script loaded');"
                + '    $.mockjaxSettings.matchInRegistrationOrder = false;'
                + '    Utils.loadScript("../mock/all.js", function () {'
                + "        console.log('mock script loaded.');"
                + '        OLS.init();'
                + '    });'
                + '});',
    "jedi_ols_st" : "OLS.init()",
    "pr" : "OLS.init()",
    "default" : "OLS.init()"
};

// 認証URLリスト
var approveurlList = {
    "dev" : "entryLoginMock.html",
    "dev_mock" : "entryLoginMock.html",
    "browserstack" : "entryLoginMock.html",
    "it1" : "entryLoginMock.html",
    "it2" : "/aw/login",
    "st" : "entryLoginMock.html",
    "jedi_ols_st" : "/aw/login/",
    "pr" : "/aw/login/",
    "default" : "/aw/login"
};

// GA実行stringリスト
var gaList = {
    "dev": "",
    "dev_mock" : "",
    "browserstack" : "",
    "it1": "",
    "it2": "",
    "st": "",
    "jedi_ols_st" : "",
    "pr": "CreateGA()",
    "default": ""
}

// WTRリスト
var wtrList = {
    "dev": "",
    "dev_mock" : "",
    "browserstack" : "",
    "it1": "",
    "it2": "http://10.157.82.62:8101/sba/js/sb_analytics_client.js",
    "st": "",
    "jedi_ols_st" : "",
    "pr": "https://wtr.mb.softbank.jp/sba/js/sb_analytics_client.js",
    "default": ""
}

// TODO トクするサポート＋？リスト
var tokusaPlusPopBtnList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/tokusuru_support_plus",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/tokusuru_support_plus",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/tokusuru_support_plus"
};

//TODO スマホおトク割？リスト
var studentDiscountPopBtnList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/gakuwari2023",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/gakuwari2023",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/gakuwari2023",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/gakuwari2023",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/gakuwari2023",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/gakuwari2023",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/gakuwari2023",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/gakuwari2023",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/gakuwari2023"
};

// あんしん保証パック with AppleCare Service B iPhone？リスト
var anshinPackAcbIpList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_ip.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_ip.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_ip.html",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packacb_ip.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packacb_ip.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_ip.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_ip.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_ip.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_ip.html"
};

// あんしん保証パック with AppleCare Service B iPad？リスト
var anshinPackAcbIdList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_id.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_id.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_id.html",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packacb_id.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packacb_id.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_id.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_id.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_id.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_id.html"
};

// あんしん保証パックプラスB SoftBank Mobile Android？リスト
var anshinPackAcbS4List = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_s4.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_s4.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_s4.html",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packpb_s4.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packpb_s4.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_s4.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_s4.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_s4.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_s4.html"
};

//あんしん保証パックネクスト Google Pixel？リスト
var anshinPackNextSpList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packnext_sp.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packnext_sp.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packnext_sp.html",
    "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packnext_sp.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packnext_sp.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packnext_sp.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packnext_sp.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packnext_sp.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packnext_sp.html"
};

// あんしん保証パックプラスB 4G ケータイ？リスト
var anshinPackPb4GList = {
  "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_4g.html",
  "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_4g.html",
  "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_4g.html",
  "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packpb_4g.html",
  "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packpb_4g.html",
  "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_4g.html",
  "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_4g.html",
  "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_4g.html",
  "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_4g.html"
};

// あんしん保証パックプラスB タブレット？リスト
var anshinPackPbTbList = {
  "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_tb.html",
  "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_tb.html",
  "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_tb.html",
  "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packpb_tb.html",
  "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packpb_tb.html",
  "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_tb.html",
  "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_tb.html",
  "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_tb.html",
  "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packpb_tb.html"
};

// あんしん保証パックB 4G ケータイ？リスト
var anshinPackB4GList = {
  "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_4g.html",
  "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_4g.html",
  "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_4g.html",
  "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packb_4g.html",
  "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packb_4g.html",
  "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_4g.html",
  "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_4g.html",
  "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_4g.html",
  "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_4g.html"
};

// あんしん保証パックB タブレット？リスト
var anshinPackBTbList = {
  "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_tb.html",
  "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_tb.html",
  "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_tb.html",
  "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packb_tb.html",
  "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packb_tb.html",
  "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_tb.html",
  "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_tb.html",
  "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packb_tb.html"
};

// あんしん保証パック Certified B 中古iPhone？リスト
var anshinPackAcbScList = {
  "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_sc.html",
  "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_sc.html",
  "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_sc.html",
  "it1" : "http://10.235.27.7:8802/ols/component/tip/anshin_packacb_sc.html",
  "it2" : "http://10.235.27.7:8802/ols/component/tip/anshin_packacb_sc.html",
  "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_sc.html",
  "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_sc.html",
  "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/anshin_packacb_sc.html"
};

// 重要オプション訴求ダイアログ iPhone iPad
// あんしん保証パック Certified B
var safePackAcbDialogIpPCList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-pc.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sc-pc.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-pc.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-pc.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sc-pc.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-pc.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-pc.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-pc.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-pc.png"
};
var safePackAcbDialogIpSPList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-sp.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sc-sp.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-sp.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-sp.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sc-sp.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-sp.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-sp.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-sp.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sc-sp.png"
};
// あんしん保証パック Certified B以外
var safePackDialogIpPCList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-pc.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-ip-pc.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-pc.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-pc.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-ip-pc.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-pc.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-pc.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-pc.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-pc.png"
};
var safePackDialogIpSPList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-sp.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-ip-sp.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-sp.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-sp.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-ip-sp.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-sp.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-sp.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-sp.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-ip-sp.png"
};

//重要オプション訴求ダイアログ SoftBank Mobile Android
var safePackDialogSpPCList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-pc.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sp-pc.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-pc.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-pc.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sp-pc.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-pc.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-pc.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-pc.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-pc.png"
};
var safePackDialogSpSPList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-sp.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sp-sp.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-sp.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-sp.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-sp-sp.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-sp.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-sp.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-sp.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-sp-sp.png"
};

//重要オプション訴求ダイアログ Google Pixel
var safePackDialogNextPCList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-pc.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-pc.png"
};
var safePackDialogNextSPList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-sp.png",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/plan/images/anshin-next-sp-sp.png"
};

// TODO トクするサポート＋ダイアログリスト
var tokusaPlusDialogList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/campaign/tokusuru_support_plus",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/campaign/tokusuru_support_plus"
};

// 新トクするサポート良品の判断基準を確認する
var newTokusaUseCriteriaUrlList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/mobile_satei_07.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_07.html"
};

// トクするサポート＋良品の判断基準を確認する
var tokusaPlusUseCriteriaUrlList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/mobile_satei_04.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_04.html"
};

// トクするサポート良品の判断基準を確認する
var tokusaUseCriteriaUrlList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/mobile_satei_03.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_03.html"
};

//下取りプログラム良品の判断基準を確認する
var mobileSatei06CriteriaUrlList = {
"dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"it2" : "http://10.235.27.7:8802/ols/component/rect/mobile_satei_06.html",
"st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html",
"default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mobile_satei_06.html"
};

// 下取りプログラム特典金額を確認する
var tradeInTokutenUrlList = {
  "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "it2" : "http://10.235.27.7:8802/ols/component/rect/trade_in_tokuten.html",
  "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html",
  "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_tokuten.html"
};

//下取りプログラム「詳細をみる」リンク先
var tradeInKisyuUrlList = {
"dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"it2" : "http://10.235.27.7:8802/ols/component/rect/trade_in_kisyu.html",
"st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html",
"default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/trade_in_kisyu.html"
};

//TODO 機種契約番号がわからない方はこちら
var useModelDetailGoodsMsnUrlList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/check_device_msn.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/check_device_msn.html"
};

// セキュリティコード？リスト
var securityCodeList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "it2" : "http://10.235.27.7:8802/ols/component/tip/security_code.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/security_code.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/security_code.html"
};

// 予約遷移
var olsApplyList = {
    "dev" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "dev_mock" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "browserstack" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "it1" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "it2" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "st" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "jedi_ols_st" : "https://st.online-reserve.mb.softbank.jp/ors/?",
    "pr" : "https://online-reserve.mb.softbank.jp/ors/?",
    "default" : "https://st.online-reserve.mb.softbank.jp/ors/?"
}

// 郵便番号を調べるリスト
var postalCodeList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/postal_code.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/postal_code.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/postal_code.html"
};

// お知らせの詳細を確認する
var mailaddressList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/mailaddress.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/mailaddress.html"
}

// 割賦契約の同意事項リスト
var installmentAgreeList = {
    "dev" : "agreement/kiyaku_contents/installment_agree.html",
    "dev_mock" : "agreement/kiyaku_contents/installment_agree.html",
    "browserstack" : "agreement/kiyaku_contents/installment_agree.html",
    "it1" : "agreement/kiyaku_contents/installment_agree.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/installment_agree.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/installment_agree.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/installment_agree.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/installment_agree.html",
    "default" : "agreement/kiyaku_contents/installment_agree.html"
}

// 個人情報の取扱・購入時の注意事項リスト
var personalInformationAttentionList = {
    "dev" : "agreement/kiyaku_contents/personal_information_attention.html",
    "dev_mock" : "agreement/kiyaku_contents/personal_information_attention.html",
    "browserstack" : "agreement/kiyaku_contents/personal_information_attention.html",
    "it1" : "agreement/kiyaku_contents/personal_information_attention.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/personal_information_attention_ps.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/personal_information_attention_ps.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/personal_information_attention_ps.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/personal_information_attention_ps.html",
    "default" : "agreement/kiyaku_contents/personal_information_attention.html"
}

// 移動機物品販売の注意事項リスト
var machineInformationAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/product_sales_agree.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/product_sales_agree.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/product_sales_agree.html"
}

// 下取りに関する同意事項
var campaignAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/trade_in.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/trade_in.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/trade_in.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/trade_in.html"
}

// 新トクするサポートに関する注意事項リスト
var newTokusuruSupportAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/new_tokusuru_support.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/new_tokusuru_support.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support.html"
}

//新トクするサポート特典利用に関する注意事項リスト
var newTokusuruSupportInfoAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/new_tokusuru_support_tokuten.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/new_tokusuru_support_tokuten.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/new_tokusuru_support_tokuten.html"
}

// トクするサポート特典利用に関する注意事項リスト
var tokusuruSupportAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/tokusuru_support.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/tokusuru_support.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support.html"
}

// トクするサポート＋特典利用に関する注意事項リスト
var tokusuruSupportPlusAttentionList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support_plus.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support_plus.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support_plus.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/tokusuru_support_plus.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/tokusuru_support_plus.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support_plus.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support_plus.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support_plus.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/tokusuru_support_plus.html"
}

// 商品の返品・交換に関する注意事項リスト
var returnList = {
    "dev" : "agreement/kiyaku_contents/return.html",
    "dev_mock" : "agreement/kiyaku_contents/return.html",
    "browserstack" : "agreement/kiyaku_contents/return.html",
    "it1" : "agreement/kiyaku_contents/return.html",
    "it2" : "agreement/kiyaku_contents/return.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/return.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/return.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/return.html",
    "default" : "agreement/kiyaku_contents/return.html"
}

// あんしん保証パックネクストに関する注意事項リスト_Pixel
var safePackNextAgreePixelList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/anshin_packnext.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/anshin_packnext.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext.html"
}

// あんしん保証パックネクストに関する注意事項リスト_シャープ
var safePackNextAgreeShList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext_sh.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext_sh.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext_sh.html",
    "it1" : "http://10.235.27.7:8802/ols/component/inc/anshin_packnext_sh.html",
    "it2" : "http://10.235.27.7:8802/ols/component/inc/anshin_packnext_sh.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext_sh.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext_sh.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext_sh.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/inc/anshin_packnext_sh.html"
}

// 機種情報Jsonリスト
var modelJsonList = {
    "dev" : "/aw/user_json/getModelInfo.json",
    "dev_mock" : "/aw/user_json/getModelInfo.json",
    "browserstack" : "/aw/user_json/getModelInfo.json",
    "it1" : "/aw/user_json/getModelInfo.json",
    "it2" : "/aw/user_json/getModelInfo.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/getModelInfo.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/getModelInfo.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/user_json/getModelInfo.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/getModelInfo.json"
}

//機種在庫情報Jsonリスト
var modelStockJsonList = {
    "dev" : "/aw/user_json/stock.json",
    "dev_mock" : "/aw/user_json/stock.json",
    "browserstack" : "/aw/user_json/stock.json",
    "it1" : "/aw/user_json/stock.json",
    "it2" : "/aw/user_json/stock.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/stock.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/stock.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/json/stock.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/stock.json"
}

//価格情報Jsonリスト
var olsPriceJsonList = {
    "dev" : "/aw/user_json/ols_price.json",
    "dev_mock" : "/aw/user_json/ols_price.json",
    "browserstack" : "/aw/user_json/ols_price.json",
    "it1" : "/aw/user_json/ols_price.json",
    "it2" : "/aw/user_json/ols_price.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/ols_price.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/ols_price.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/json/ols_price.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/ols_price.json"
}

//特定グループ情報JSONリスト
var specificGroupInfoJsonList = {
    "dev" : "/aw/user_json/getSpecificGroupInfo.json",
    "dev_mock" : "/aw/user_json/getSpecificGroupInfo.json",
    "browserstack" : "/aw/user_json/getSpecificGroupInfo.json",
    "it1" : "/aw/user_json/getSpecificGroupInfo.json",
    "it2" : "/aw/user_json/getSpecificGroupInfo.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/getSpecificGroupInfo.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/getSpecificGroupInfo.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/user_json/getSpecificGroupInfo.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_json/getSpecificGroupInfo.json"
}

// 学割キャンペーンJsonリスト
var studentDiscountPriceJsonList = {
    "dev" : "/aw/user_json/cp_gakuwari001_ols_price.json",
    "dev_mock" : "/aw/user_json/cp_gakuwari001_ols_price.json",
    "browserstack" : "/aw/user_json/cp_gakuwari001_ols_price.json",
    "it1" : "/aw/user_json/cp_gakuwari001_ols_price.json",
    "it2" : "/aw/user_json/cp_gakuwari001_ols_price.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/cp_gakuwari001_ols_price.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/cp_gakuwari001_ols_price.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/json/cp_gakuwari001_ols_price.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/cp_gakuwari001_ols_price.json"
}

//商品紐づけサービス情報Jsonリスト
var itmSvcJsonList = {
    "dev" : "/aw/user_json/itmSvc.json",
    "dev_mock" : "/aw/user_json/itmSvc.json",
    "browserstack" : "/aw/user_json/itmSvc.json",
    "it1" : "/aw/user_json/itmSvc.json",
    "it2" : "/aw/user_json/itmSvc.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/itmSvc.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/itmSvc.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/json/itmSvc.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/itmSvc.json"
}

//オプション情報（あんしん保証）Jsonリスト
var afterServiceJsonList = {
    "dev" : "/aw/user_json/getAfterServiceInfo.json",
    "dev_mock" : "/aw/user_json/getAfterServiceInfo.json",
    "browserstack" : "/aw/user_json/getAfterServiceInfo.json",
    "it1" : "/aw/user_json/getAfterServiceInfo.json",
    "it2" : "/aw/user_json/getAfterServiceInfo.json",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/getAfterServiceInfo.json",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/getAfterServiceInfo.json",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/json/getAfterServiceInfo.json",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/json/getAfterServiceInfo.json"
}

// 本人確認について更に詳しく見るリスト
var selfConfirmDetailList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "it2" : "http://10.235.27.7:8802/ols/component/rect/self_confirm_detail.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/rect/self_confirm_detail.html"
}

// クレジット番号等を設定し、トークンPANを取得(TOR)
var TOR_URL = {
    "dev" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "dev_mock" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "browserstack" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "it1" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "it2" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "st" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "jedi_ols_st" : "https://st.torapj.mb.softbank.jp/tor/api/authori",
    "pr" : "https://torapj.mb.softbank.jp/tor/api/authori",
    "default" : "https://st.torapj.mb.softbank.jp/tor/api/authori"
}
var TOR_URL_IP = {
    "dev" : "http://10.157.83.218:18080/tor/api/authori",
    "dev_mock" : "http://10.157.83.218:18080/tor/api/authori",
    "browserstack" : "http://10.157.83.218:18080/tor/api/authori",
    "it1" : "http://10.157.83.218:18080/tor/api/authori",
    "it2" : "http://10.157.83.218:18080/tor/api/authori",
    "st" : "http://10.157.83.218:18080/tor/api/authori",
    "jedi_ols_st" : "http://10.157.83.218:18080/tor/api/authori",
    "pr" : "https://torapj.mb.softbank.jp/tor/api/authori",
    "default" : "http://10.157.83.218:18080/tor/api/authori"
}
// SBPSトークンシステムURL
var SBPS_TOKEN_URL = {
    "dev" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "dev_mock" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "browserstack" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "it1" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "it2" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "st" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "jedi_ols_st" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "pr" : "https://token.sps-system.com/sbpstoken/com_sbps_system_token.js",
    "default" : "https://stbtoken.sps-system.com/sbpstoken/com_sbps_system_token.js"
}
/**
 * TORモックフラグ。
 * 0:TOR通信をモック化しない
 * 1:TOR通信をモック化する
 * @const
 */
var TOR_MOCK_FLG = {
    "dev" : "1",
    "dev_mock" : "1",
    "browserstack" : "1",
    "it1" : "0",
    "it2" : "0",
    "st" : "0",
    "jedi_ols_st" : "0",
    "pr" : "0",
    "default" : "0"
}
/**
 * SBPS通信フラグ。
 * 0:SBPS通信をしない
 * 1:SBPS通信をする
 * @const
 */
var SBPS_COMMUNICATION_FLG = {
    "dev" : "0",
    "dev_mock" : "0",
    "browserstack" : "0",
    "it1" : "1",
    "it2" : "1",
    "st" : "1",
    "jedi_ols_st" : "1",
    "pr" : "1",
    "default" : "1"
}
// クレジット番号等を設定し、トークンPAN取得用ｊｓパス
var PCIDSS_PASS = {
    "dev" : "../js/pcidss-mock.js?v=",
    "dev_mock" : "../js/pcidss-mock.js?v=",
    "browserstack" : "../js/pcidss-mock.js?v=",
    "it1" : "../js/pcidss.js?v=",
    "it2" : "../js/pcidss.js?v=",
    "st" : "../js/pcidss.js?v=",
    "jedi_ols_st" : "../js/pcidss.js?v=",
    "pr" : "../js/pcidss.js?v=",
    "default" : "../js/pcidss.js?v="
}

//Coming Soonページリスト
var comingSoonPageList = {
    "dev" : "http://10.235.27.7:8802/ols/html/order/index.html",
    "dev_mock" : "http://10.235.27.7:8802/ols/html/order/index.html",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index.html",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index.html",
    "it2" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index.html",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index.html",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index.html",
    "pr" : "https://online-shop.mb.softbank.jp/ols/html/order/index.html",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index.html"
}

//認証logout
var logoutList = {
    "dev" : "../js/j_ua.js",
    "dev_mock" : "../js/j_ua.js",
    "browserstack" : "../js/j_ua.js",
    "it1" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "it2" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "st" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "jedi_ols_st" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "pr" : "https://id.my.softbank.jp/sbid_auth/type1/2.0/logout.php",
    "default" : "https://st.id.softbank.jp/sbid_auth/type1/2.0/logout.php"
}

// 店舗画像
var shopLogoList = {
    "dev" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "dev_mock" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "it2" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/common/header/images/agency/",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/component/common/header/images/agency/"
}

// メリットリンクURL
// 受取方法:1/未指定→ shop_receive_merit1.html
// 受取方法:4→shop_receive_merit4.html
// 受取方法:5→shop_receive_merit5.html
// 受取方法:6→shop_receive_merit6.html
// 受取方法:7→shop_receive_merit7.html
var prdMeritLinkList = {
    "dev" : "http://10.235.27.7:8802/ols/component/tip/shop_receive_merit",
    "dev_mock" : "http://10.235.27.7:8802/ols/component/tip/shop_receive_merit",
    "browserstack" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/shop_receive_merit",
    "it1" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/shop_receive_merit",
    "it2" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/shop_receive_merit",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/shop_receive_merit",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/component/tip/shop_receive_merit",
    "pr" : "https://online-shop.mb.softbank.jp/ols/component/tip/shop_receive_merit",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/html/order/index.html"
}

// O2O許可代理店 
var allowAgncyIdO2OList = {
    "dev" : "/aw/user_json/allowAgncyId_o2o.txt",
    "dev_mock" : "/aw/user_json/allowAgncyId_o2o.txt",
    "browserstack" : "/aw/user_json/allowAgncyId_o2o.txt",
    "it1" : "/aw/user_json/allowAgncyId_o2o.txt",
    "it2" : "/aw/user_json/allowAgncyId_o2o.txt",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_o2o.txt",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_o2o.txt",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_o2o.txt",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_o2o.txt"
}

// 直送許可代理店
var allowAgncyIdDirectList = {
    "dev" : "/aw/user_json/allowAgncyId_direct.txt",
    "dev_mock" : "/aw/user_json/allowAgncyId_direct.txt",
    "browserstack" : "/aw/user_json/allowAgncyId_direct.txt",
    "it1" : "/aw/user_json/allowAgncyId_direct.txt",
    "it2" : "/aw/user_json/allowAgncyId_direct.txt",
    "st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_direct.txt",
    "jedi_ols_st" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_direct.txt",
    "pr" : "https://online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_direct.txt",
    "default" : "https://st.online-shop.mb.softbank.jp/ols/mobile/products/user_text/allowAgncyId_direct.txt"
}
